import { CIcon } from '~/icons/types'
export const ciMessage: CIcon = {
  width: 512,
  height: 384,
  paths: [
    {
      d:
        'M442.1 0H69.9C31.3 0 0 31.3 0 69.9v244.2C0 352.7 31.3 384 69.9 384h372.3c38.6 0 69.9-31.3 69.9-69.9V69.9C512 31.3 480.7 0 442.1 0zm0 21c9.9 0 19 2.9 26.7 8L274.1 223.8c-10 10-26.2 10-36.2 0L43.1 29c7.7-5 16.9-8 26.7-8h372.3zM491 314.1c0 26.9-21.9 48.9-48.9 48.9H69.9c-27 0-48.9-21.9-48.9-48.9V69.9c0-9.5 2.7-18.4 7.4-25.9L223 238.7c9.1 9.1 21 13.6 32.9 13.6 11.9 0 23.8-4.5 32.9-13.6L483.6 44c4.7 7.5 7.4 16.4 7.4 25.9v244.2z'
    }
  ],
  name: 'message',
  type: 'regular'
}
